import { Button } from "@/src/components/buttons";
import { CompartmentCard } from "@/src/components/cards";
import { closeDrawer, openDrawer } from "@/src/components/dialogs";
import { Input } from "@/src/components/universalInput";
import { Income } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getUserId, jsonAbstract } from "@/src/utils/utils";
import { useState } from "react";
import { CreditsList } from "./creditsList";

export function PaymentForm({
  current,
  onPay,
}: {
  current?: Income;
  onPay: (newValue: Income) => void;
}) {
  let [reduction, setReduction] = useState(0);
  let [income, setIncome] = useState(current || ({} as Income));
  function setNewValue(newValue: Income) {
    setIncome(newValue);
  }

  async function encaisser() {
    let credits = income.credits || [];
    if (reduction) {
      let credit = await apiFetch("credits", "addOne", {
        credit: {
          amount: reduction,
          patient: current?.patient,
          creator: getUserId(),
          income: current,
          status: "pending",
        },
      });
      if (!credit) return;
      credits.push(credit);
    }

    let newValue: Income = {
      ...income,
      total: income.total - reduction,
      credits,
      status: "paid",
    };

    newValue.creator = getUserId();
    newValue = await apiFetch("incomes", "addOne", {
      income: newValue,
    });

    setNewValue({ ...newValue });
    onPay({ ...newValue });
  }

  return (
    <div className="grid c1 gap10">
      {income?.status === "pending" && (
        <CompartmentCard title="Encaissement">
          <div className="c1 gap10">
            <Input
              name=""
              shouldFocus={true}
              type="number"
              value={income.total - reduction}
              onEnter={async () => {
                if (income.status == "paid") {
                  closeDrawer("incomePayment");
                } else {
                  await encaisser();
                }
              }}
              onChange={(newValue) => {
                if (newValue > income.total) {
                  newValue = income.total;
                }
                setReduction(income.total - newValue);
              }}
            ></Input>
            <Button
              onClick={async () => {
                await encaisser();
              }}
            >
              Encaisser {income.total - reduction} DZD{" "}
              {reduction ? `(- ${reduction} DZD)` : ""}
            </Button>
          </div>
        </CompartmentCard>
      )}
      {income?.status === "paid" && (
        <div className="p30 gray center">
          <div className="bold">Encaissé</div>
          <div className="gray">{income.total} DZD</div>
        </div>
      )}
      <CreditsList patientId={income?.patient?.id}></CreditsList>
    </div>
  );
}

export async function openPaymentForm({
  income,
  onChange,
}: {
  income: Income;
  onChange: (income: Income) => void;
}) {
  let localIncome = jsonAbstract(income) as Income;
  await openDrawer({
    id: "incomePayment",
    title: "Encaisser",

    content: (
      <PaymentForm
        current={localIncome}
        onPay={async (newValue) => {
          onChange(newValue);
          closeDrawer("incomePayment");
        }}
      />
    ),
    footer: <div></div>,
  });
}
